import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import {
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    InputAdornment,
    TextField,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import {
    LoadingBar,
    Select,
    CircularLoading,
    FilterList,
    ButtonWithIcon,
    DateInput,
} from '../../../components/Common';
import {
    getReasonsForLetters,
    contactEpafilterOptionColumns,
    locationLabelStyle,
    searchBarStyle,
} from '../utils';
import { fetchFilterValues, postRequestHeaders, FormatDate } from '../../../utils';
import AssetSelect from './AssetSelect';
import Routes from '../../../routes';
import UserInfo from '../../../UserInfo';
import { TranslateW } from '../../../Utils/Languages/Translate';

const ContactEPA = ({}) => {
    const [state, setAllState] = useState({
        locations: [],
        savedLocations: [],
        letterOptions: [],
        letterToPrint: "",
        plannedReturnedToServiceDate: "",
        newRetirementDate: "",
        originalRetirementDate: "",
        year: "",
        reasonForLetterOptions: [], // these change based on the letter
        locationsAndAssetsForLetter: [],
        reasonForLetter: "",
        loading: true,
        reportLoading: false,
        expanded: '',
        searchTerm: '',
        assetIdsForReport: [],
        selectedAsset: '',
        selectedAssetLocationId: '',
        materialTypes: [],
        renderSuccess: true,
        exportLoading: false,
        errors: {
            movedTo: false,
        },
    });

    const [filterState, setNewFilterState] = useState({
        tableURL: "ContactEPA/",
        filterListOptions: contactEpafilterOptionColumns,
        filterValues: [],
        filters: sessionStorage.getItem("ContactEPA/" + "filters" + UserInfo.instanceId) == null ? [] : JSON.parse(sessionStorage.getItem("ContactEPA/" + "filters" + UserInfo.instanceId)),
        appliedFilters: [],
        open: false,
        loading: false,
        selectedFilter: null,
        clearFilters: sessionStorage.getItem("ContactEPA/" + "filters" + UserInfo.instanceId) == null ? false : true,
    });

    const renderFilters = (filterState.filterListOptions.length > 0 && state.letterToPrint);
    const isLeakRepairExtensionLetter = state.letterToPrint === 2;
    const isRetirementPlanExtensionLetter = state.letterToPrint === 4;
    const isChronicallyLeakySystemLetter = state.letterToPrint === 5;
    const currentYear = moment().year();
    const yearOptions = [
        { label: `${currentYear}`, value: currentYear },
        { label: `${currentYear - 1}`, value: currentYear - 1 },
        { label: `${currentYear - 2}`, value: currentYear - 2 },
        { label: `${currentYear - 3}`, value: currentYear - 3 }
    ];
    const exportDisabled = (
        !state.letterToPrint
        || state.assetIdsForReport.length <= 0
        || state.exportLoading
        || (
            isLeakRepairExtensionLetter
            && !state.plannedReturnedToServiceDate
        )
        || (
            isChronicallyLeakySystemLetter
            && !state.year
        )
        || (
            !isLeakRepairExtensionLetter
            && !isChronicallyLeakySystemLetter
            && !state.reasonForLetter
        )
        || (
            isRetirementPlanExtensionLetter
            && (!state.originalRetirementDate || !state.newRetirementDate)
        )
    );

    const setState = (new_state_obj) => (
        setAllState((prevState) => (
            { ...prevState, ...new_state_obj }
        ))
    );

    const setFilterState = (new_filter_state_obj) => (
        setNewFilterState((prevFilterState) => (
            { ...prevFilterState, ...new_filter_state_obj }
        ))
    );

    const fetchLocationsWithAssets = async (reportId, year = null) => {
        const yearFilter = year ? [{ property: 'year', value: String(year) }] : [];
        const raw_location_data = await fetch(
            Routes.Location.GetLocationsWithAssetsContactEPA(reportId),
            {
                method: 'POST',
                headers: { ...postRequestHeaders },
                body: JSON.stringify({
                    filters: [...filterState.filters, ...yearFilter]
                })
            }
        );

        const locations = await raw_location_data.json();
        const locationsWithAssets = locations.filter(l => l.assets.length > 0);
        return locationsWithAssets;
    };

    const printLetter = async () => {
        console.log('asset Ids for report', state.assetIdsForReport);
        let reasonForLetterString = "";
        const reportIds = {
            1: "6b7c8e09-7829-4a0a-83a1-280500804852",
            2: "c2eb2425-d54d-4832-ad51-67abc339bd05",
            4: "c7bccd06-1052-4b97-9c06-73e8854ce0c7",
            5: "5c32d684-763f-4ee0-8c56-3b9d0e88be8b"
        };

        if (!isChronicallyLeakySystemLetter) {
            reasonForLetterString = getReasonsForLetters(state.letterToPrint).find(l => l.id === state.reasonForLetter).label;
        }

        console.log('report ID to print', reportIds[state.letterToPrint]);
        console.log('reason for letter string', reasonForLetterString);
        try {
            toast.loading("Your PDF is generating. Please standby..");
            setState({ exportLoading: true, expanded: '' });
            const promiseArray = state.assetIdsForReport.map((assetId) => {
                return fetch(
                    Routes.PowerBI.ContactEpaExport(),
                    {
                        method: 'POST',
                        headers: { ...postRequestHeaders },
                        body: JSON.stringify({
                            reportId: reportIds[state.letterToPrint],
                            assetId,
                            reasonForLetter: reasonForLetterString,
                            originalRetirementDate: FormatDate(state.originalRetirementDate, true),
                            newRetirementDate: FormatDate(state.newRetirementDate, true),
                            calendarYear: state.year,
                            plannedReturnedToServiceDate: FormatDate(state.plannedReturnedToServiceDate, true)
                        })
                    }
                );
            });

            await Promise
                .all(promiseArray)
                .then(res => {
                    console.log('what is the res', res);
                    res.map(async (fileStream) => {
                        const blob = await fileStream.blob();
                        const file = new Blob([blob], { type: "application/pdf" });
                        const fileURL = URL.createObjectURL(file);
                        window.open(fileURL);
                    });
                });
            toast.dismiss();
            toast.success("Your PDF is ready", { duration: 5000 });
        } catch (error) {
            console.error('PDF failed to create');
            console.error(error);
            toast.error('PDF failed to create', { duration: 5000 });
        } finally {
            setState({ exportLoading: false });
        }
    };

    const fetchLetterOptions = async () => {
        const letters = await fetch(Routes.Letter.GetContactEpaLetters());
        const letterOptions = await letters.json();
        return letterOptions;
    };

    const fetchData = async () => {
        await Promise.all([
            fetchLetterOptions(),
            fetchFilterValues(Routes.Asset.FetchContactEPAFilterValues())
        ]).then(([letterOptions, filterValues]) => {
            setFilterState({ filterValues });
            return setState({
                letterOptions,
                loading: false
            });

        })
            .catch((error) => {
                toast.error('Could not fetch Contact EPA letters!', { duration: 5000 });
                console.log('Error', error);
            });
    };

    const handleLetterChange = async (letterToPrint) => {
        setFilterState({ loading: true });
        setState({
            reasonForLetter: "",
            year: "",
            originalRetirementDate: "",
            newRetirementDate: ""
        });
        const newState = { letterToPrint };
        if (!letterToPrint) {
            newState.reasonForLetter = "";
            newState.letterToPrint = "";
            return setState({
                ...newState,
                locations: [],
                savedLocations: [],
            });
        }

        const locationsWithAssets = await fetchLocationsWithAssets(letterToPrint);

        setState({
            ...newState,
            assetIdsForReport: [],
            locations: locationsWithAssets,
            savedLocations: locationsWithAssets,
            reasonForLetterOptions: getReasonsForLetters(letterToPrint)
        });
        return setFilterState({ loading: false });
    };

    const handleOpen = (panelIdToOpen, isExpanded) => {
        const open = isExpanded ? panelIdToOpen : false;
        return setState({ expanded: open });
    };

    const searchAssets = (assets, searchTerm) => (
        assets.filter(c => c.name.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const handleSearch = (searchTerm, locationId) => {
        setState({ searchTerm });
        const { savedLocations } = state;
        let locations = [...savedLocations];
        const locationIndex = savedLocations.findIndex(l => l.id === locationId);
        const searchAssetLocation = savedLocations.find(l => l.id === locationId);
        let filteredDropDownLocation = { ...searchAssetLocation };
        const { assets } = searchAssetLocation;
        const searchResults = searchAssets(assets, searchTerm);
        console.log('searchResults', searchResults);
        filteredDropDownLocation.assets = searchResults;
        locations[locationIndex] = filteredDropDownLocation;

        return setState({ locations });
    };

    const setChecked = (isChecked, assetId, locationId) => {
        const { assetIdsForReport, locationsAndAssetsForLetter } = state;
        const location = locationsAndAssetsForLetter.find(l => l.locationId === locationId) || {};
        const newLocations = locationsAndAssetsForLetter.filter(l => l.locationId !== locationId);
        const { assetIds = [] } = location;

        // remove asset ID from list
        if (!isChecked) {
            // array of assetIds used for checkbox - simple, keep this
            const filteredAssetIdList = assetIdsForReport.filter(id => id !== assetId);

            const filteredAssets = assetIds.filter(id => id !== assetId);
            const locationWithFilteredAssetId = { locationId, assetIds: filteredAssets };
            if (filteredAssets.length > 0) {
                newLocations.push(locationWithFilteredAssetId);
            }

            return setState({
                assetIdsForReport: filteredAssetIdList,
                locationsAndAssetsForLetter: newLocations,
            });
        }

        // add assetId to list
        const newAssetIds = [...assetIds, assetId];
        const locationWithAddedAssetId = { locationId, assetIds: newAssetIds };
        newLocations.push(locationWithAddedAssetId);

        return setState({
            assetIdsForReport: [...assetIdsForReport, assetId],
            locationsAndAssetsForLetter: newLocations,
        });
    };

    const handleClearFilters = (e) => {
        e.stopPropagation();
        sessionStorage.removeItem(filterState.tableURL + "filters" + UserInfo.instanceId);
        return setFilterState({
            loading: true,
            filters: [],
            clearFilters: true,
        });
    };

    const handleYearChange = async (year) => {
        setState({ year, assetIdsForReport: [], locationsAndAssetsForLetter: [] });
        if (year) {
            setFilterState({ loading: true });
            const locationsWithAssets = await fetchLocationsWithAssets(state.letterToPrint, year);
            setState({ locations: locationsWithAssets, savedLocations: locationsWithAssets });
            setFilterState({ loading: false });
        }
    };

    const renderLocationLabel = (locationName, numberOfAssets) => (
        filterState.loading ? (
            <>
                {`${locationName}`} <CircularLoading size={15} marginLeft={1} />
            </>
        ) : (
            <>
                {`${locationName} (${numberOfAssets})`}
            </>
        )
    );

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (filterState.filters.length > 0 || filterState.clearFilters) {
            setState({ expanded: '' });
            setFilterState({ loading: true });
            const year = isChronicallyLeakySystemLetter ? state.year : null;
            const getData = async () => {
                const locationsWithAssets = await fetchLocationsWithAssets(state.letterToPrint, year);
                return locationsWithAssets;
            };

            getData()
                .then(locationsWithAssets => setState({
                    locations: locationsWithAssets,
                    savedLocations: locationsWithAssets
                }))
                .finally(() => setFilterState({ loading: false }));
        }
    }, [filterState.filters, filterState.clearFilters]);

    if (state.loading) {
        return <LoadingBar />;
    }

    return (
        <>
            <Grid container item>
                <ButtonWithIcon
                    buttonText='Export Letter (.pdf)'
                    onClick={printLetter}
                    iconPosition="start"
                    Icon={FileUploadOutlinedIcon}
                    disabled={exportDisabled}
                />
            </Grid>
            <Grid
                container
                spacing={2}
                xs={10} md={10} lg={10}
                sx={{ marginTop: '1%' }}
            >
                <Grid item xs={6}>
                    <Select
                        required
                        showNullOption
                        label="Letter to Print"
                        value={state.letterToPrint}
                        onChange={e => handleLetterChange(e.target.value)}
                        options={state.letterOptions}
                        error={!state.letterToPrint}
                        customHelperText={!state.letterToPrint ? "Please select a letter" : ""}
                    />
                </Grid>

                <Grid item xs={6}>
                    {isChronicallyLeakySystemLetter ? (
                        <Select
                            required
                            label="Year"
                            value={state.year}
                            onChange={e => handleYearChange(e.target.value)}
                            options={yearOptions}
                        />
                    ) : (
                        <Select
                            required
                            label="Reason for Letter"
                            value={state.reasonForLetter}
                            onChange={e => setState({ reasonForLetter: e.target.value })}
                            options={state.reasonForLetterOptions}
                            disabled={!state.letterToPrint}
                        />
                    )}
                </Grid>

                {isLeakRepairExtensionLetter && (
                    <Grid item xs={6}>
                        <DateInput
                            required
                            allowFuture
                            allowPast
                            label="Planned Return to Service Date*"
                            date={state.plannedReturnedToServiceDate}
                            onChange={new_date => setState({ plannedReturnedToServiceDate: new_date })}
                        />
                    </Grid>
                )}

                {isRetirementPlanExtensionLetter && (
                    <>
                        <Grid item xs={6}>
                            <DateInput
                                required
                                allowFuture
                                allowPast
                                label="Original Retirement Date*"
                                date={state.originalRetirementDate}
                                onChange={new_date => setState({ originalRetirementDate: new_date })}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <DateInput
                                required
                                allowFuture
                                allowPast
                                label="New Retirement Date*"
                                date={state.newRetirementDate}
                                onChange={new_date => setState({ newRetirementDate: new_date })}
                            />
                        </Grid>
                    </>
                )}
            </Grid>

            <Grid
                container
                spacing={2}
                direction="row"
                sx={{ width: '100%', marginTop: '2%' }}
            >

                {renderFilters && (
                    <>

                        <Grid item sx={2} md={2} lg={2}>
                            <span className='contactEpaSelectSystems'>
                                Select Systems
                            </span>
                        </Grid>

                        <Grid item sx={8} md={8} lg={8}>
                            <FilterList
                                tableURL={filterState.tableURL}
                                filters={filterState.filterListOptions}
                                filterValues={filterState.filterValues}
                                appliedFilters={filterState.filters}
                                setAppliedFilters={appliedFilters => setFilterState({ filters: appliedFilters })}
                                filterListOpen={filterState.open}
                                setFilterListOpen={() => setFilterState({ open: !filterState.open })}
                                selectedFilter={filterState.selectedFilter}
                                setSelectedFilter={selectedFilter => setFilterState({ selectedFilter })}
                                handleClearFilters={handleClearFilters}
                                setClearFilters={clearFilters => setFilterState({ clearFilters })}
                            />
                        </Grid>
                    </>
                )}

                {state.locations.map((location) => (
                    <Grid item xs={10} md={10} lg={10}>
                        <Accordion
                            variant='outlined'
                            disabled={filterState.loading || state.exportLoading}
                            expanded={state.expanded === location.id}
                            onChange={(e, isExpanded) => handleOpen(location.id, isExpanded)}
                            TransitionProps={{ unmountOnExit: true }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography sx={locationLabelStyle}>
                                    {renderLocationLabel(location.name, location.assets.length)}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <TextField
                                    label="Search For Systems"
                                    variant="outlined"
                                    value={state.searchTerm}
                                    onChange={e => handleSearch(e.target.value, location.id)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={searchBarStyle}
                                />
                                <AssetSelect
                                    locationId={location.id}
                                    setChecked={setChecked}
                                    assets={location.assets}
                                    assetIdsForReport={state.assetIdsForReport}
                                />
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default withRouter(ContactEPA);
